'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _irisPropTypes = require('@spp/iris-prop-types');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var formatSrcSet = function formatSrcSet(urls) {
    return urls.sort(function (a, b) {
        return b.width - a.width;
    }) // Sort from large to small; iOS8 picks the first image.
    .map(function (_ref) {
        var url = _ref.url,
            width = _ref.width;
        return url + ' ' + width + 'w';
    }).join(',');
};

var getPreferredImage = function getPreferredImage(urls) {
    return urls.reduce(function (previous, current) {
        return current.width > previous.width ? current : previous;
    });
};

var ImageAsset = function ImageAsset(_ref2) {
    var theme = _ref2.theme,
        urls = _ref2.urls,
        sizes = _ref2.sizes,
        altText = _ref2.altText,
        width = _ref2.width,
        testTag = _ref2.testTag;

    var preferredImage = getPreferredImage(urls);
    var srcSet = formatSrcSet(urls);

    return _react2.default.createElement('img', {
        className: theme,
        src: preferredImage.url,
        srcSet: srcSet,
        sizes: sizes,
        alt: altText,
        width: width,
        'data-test-tag': testTag
    });
};

// https://github.schibsted.io/smp-distribution/format/blob/master/iris/v4/objects.md#image-asset
ImageAsset.propTypes = {
    altText: _propTypes2.default.string,
    theme: _propTypes2.default.string,
    urls: _propTypes2.default.arrayOf(_irisPropTypes.objects.imageUrl).isRequired,
    sizes: _propTypes2.default.string,
    width: _propTypes2.default.number,
    testTag: _propTypes2.default.string
};

ImageAsset.defaultProps = {
    altText: '',
    id: '',
    theme: '',
    sizes: undefined,
    width: undefined,
    testTag: '@spp/ui-image-asset'
};

exports.default = ImageAsset;
//# sourceMappingURL=ImageAsset.js.map


/*****************
 ** WEBPACK FOOTER
 ** ./~/@spp/ui-image/lib/cjs/ImageAsset/ImageAsset.js
 ** module id = 661
 ** module chunks = 1
 **/